import GeoUtils from '@front/volcanion/utils/geo'
import { I18n } from '@front/volcanion'

import moment from 'moment'

import Aux from './Aux'

class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        client_id: record?.client_id,
        name: record?.name,
        auth_account: record?.auth_account,
        availableSince: record?.availableSince,
        availableUntil: record?.availableUntil,
        comment: record?.comment,
        ivr_access: record?.ivr_access,
        invoice_type: record?.invoice_type,
        contact: record?.contact,
        formula: record?.formula,
        allow_auto_subscription: record?.allow_auto_subscription,
        payment_types: !_.isEmpty(record?.payment_types) ? _.map(record?.payment_types, 'paymenttype') : undefined,
        status: Aux.loadStatus(record),
        commpanycontract_pricerule: record?.commpanycontract_pricerule,
        ...Aux.loadAuthenticationType(record?.authentication_type),
        address: { formatted_address: GeoUtils.mergeAddress(record?.source_address) },
        source_address: record?.source_address,
        exclude_heatmap: record?.exclude_heatmap,
        bypass_heatmap_cascade: record?.bypass_heatmap_cascade,
        delayAtSourceType: _.isNull(record?.delay_at_source) ? 'default' : 'custom',
        delay_at_source: record?.delay_at_source,
        priority: record?.priority,
        customer_discount: record?.customer_discount * 100,
        driver_discount: record?.driver_discount * 100,
        excluded_commercial_packages: _.map(record?.excluded_commercial_packages, 'commercial_package_id')
      }
    }
  }

  static getEmptyFormHandler() {
    return function getEmptyFormValues() {
      return {
        status: 'active',
        invoice_type: 'do',
        availableSince: moment.utc().format(),
        formula: null,
        direct_access: false,
        display_list: false,
        auth_account: false,
        allow_auto_subscription: false,
        delayAtSourceType: 'default'
      }
    }
  }

  static formToRecordHandler(company, operator, companycontract) {
    return function formToRecord(values, extra, meta, state) {
      return {
        company,
        client_id: values?.client_id,
        name: values?.name,
        auth_account: values?.auth_account,
        availableSince: Aux.exportDate(values?.availableSince, { hour: 0, minute: 1, second: 0 }),
        availableUntil: Aux.exportDate(values?.availableUntil, { hour: 23, minute: 59, second: 59 }),
        comment: _.has(values, 'comment') ? _.merge({}, values?.comment, { type: 'MVOTypbow', report: operator, category: 'JFPNk9Qxj' }) : undefined,
        ivr_access: values?.ivr_access,
        invoice_type: values?.invoice_type,
        contact: values?.contact,
        allow_auto_subscription: values?.allow_auto_subscription,
        payment_types: _.has(values, 'payment_types') ? _.map(values?.payment_types, elem => ({
          paymenttype: elem,
          companycontract
        })) : undefined,
        formula: values?.formula,
        commpanycontract_pricerule: values?.commpanycontract_pricerule,
        authentication_type: Aux.exportAuthenticationType(values?.direct_access, values?.display_list),
        ...Aux.exportStatus(values?.status),
        source_address: values?.source_address,
        exclude_heatmap: values?.exclude_heatmap,
        bypass_heatmap_cascade: values?.bypass_heatmap_cascade,
        delay_at_source: values?.delayAtSourceType === 'custom' ? values?.delay_at_source : null,
        priority: values?.priority,
        customer_discount: _.isFinite(values?.customer_discount) ? values.customer_discount / 100 : undefined,
        driver_discount: _.isFinite(values?.driver_discount) ? values.driver_discount / 100 : undefined,
        excluded_commercial_packages: values?.excluded_commercial_packages
      }
    }
  }

  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        record_id: record?.companycontract_id,
        title: record?.client_id,
        enableCustomPayment: !_.isEmpty(record?.payment_types),
      }
    }
  }

  static formToOptionsHandler() {
    return function formToOptions(values, extra, meta, state) {
      return { force_order_cancel: !!extra?.forceSubmit }
    }
  }

  static onSubmitSuccessHandler(requestSubmitOrderLimit) {
    return async function onSubmitSuccess(result, values, extra, meta, state) {
      !!requestSubmitOrderLimit && requestSubmitOrderLimit({ companycontract: result?.companycontract_id })
    }
  }

  static onSubmitFailedHandler(openDialog) {
    return async function onSubmitFailed(err, values, extra, meta) {
      if (err?.code === 'ACTIVE_JOBS')
        openDialog('show_active_jobs', {
          title: I18n.t('driver.popup.show_active_jobs.pending_orders.title'),
          description: I18n.t('driver.popup.show_active_jobs.pending_orders.description', { entity: I18n.t('driver.popup.show_active_jobs.entity.companycontract') }),
          job_ids: err?.context?.job_ids,
        })
    }
  }
}

export default Callbacks
